export default {
  title: 'Programma fedeltà',
};
